export const AppOfflineMessage = `Your internet connection appears to be offline. Please check your data or wifi connection.`;
export const PrintingFailedMessage = `Uh oh! There was a problem printing.`;
